import React from "react";
import { Outlet } from "react-router-dom";
import CreateAccountComponent from "../pages/CreateAccountComponent";
import NotFoundComponent from "../pages/NotFoundComponent";
import HeaderComponent from "../pages/HeaderComponent";
import VerifyEmailComponent from "../pages/VerifyEmailComponent";
import VerifySuccessComponent from "../pages/VerifySuccessComponent";
import LoginPageComponent from "../pages/LoginPageComponent";
import DashboardComponent from "../pages/DashboardComponent";
import MockQuestionComponent from "../pages/MockQuestionComponent";
import ResultComponent from "../pages/ResultComponent";
import MockCompletedComponent from "../pages/MockCompletedComponent";
import PricingComponent from "../pages/PricingComponent";
import TestComponents from "../pages/TestComponents";
import ProfileComponents from "../pages/ProfileComponents";
import ForgotPasswordComponent from "../pages/ForgotPasswordComponent";
import ResetPasswordComponent from "../pages/ResetPasswordComponent";
import PricingCheckoutComponent from "../pages/PricingCheckoutComponent";
import SuccessPaymentComponents from "../pages/SuccessPaymentComponents";
import CancelPaymentComponents from "../pages/CancelPaymentComponents";
import TestQuestionComponents from "../pages/TestQuestionComponents";
import FooterComponents from "../pages/FooterComponents";

export function Router() {
  return (
    <>
      <div>
        <HeaderComponent />
        <div style={{ minHeight: "calc(100vh - 157px)" }}>
          <Outlet />
        </div>
        <FooterComponents />
      </div>
    </>
  );
}

export const routes = [
  { path: "/", component: <LoginPageComponent /> },
  { path: "/register", component: <CreateAccountComponent /> },
  { path: "/verify-mail", component: <VerifyEmailComponent /> },
  { path: "/verify-success", component: <VerifySuccessComponent /> },
  { path: "/forgot-password", component: <ForgotPasswordComponent /> },
  { path: "/reset-password", component: <ResetPasswordComponent /> },

  // { path: "/mock-questions", component: <MockQuestionComponent /> },
  // { path: "/mock-completed", component: <MockCompletedComponent /> },

  { path: "/dashboard", component: <DashboardComponent /> },
  { path: "/result", component: <ResultComponent /> },
  { path: "/test", component: <TestComponents /> },
  { path: "/test-question", component: <TestQuestionComponents /> },
  { path: "/profile", component: <ProfileComponents /> },
  { path: "/pricing", component: <PricingComponent /> },
  { path: "/checkout", component: <PricingCheckoutComponent /> },

  { path: "/success-payment", component: <SuccessPaymentComponents /> },
  { path: "/cancel-payment", component: <CancelPaymentComponents /> },

  { path: "*", component: <NotFoundComponent /> },
];
